// Justificativa estruturada pelos 5 critérios SAES
// (salva como JSON { _saes: 2, c: [5 textos] }; texto livre antigo continua aceito)

// ─── Critérios SAES — usados como guia visual na justificativa ────────────────
export const CRITERIOS_SAES = [
  { num: '01', label: 'O QUE SERÁ REALIZADO', desc: 'Descrição clara e objetiva do objeto/ação a ser executada, especificando as atividades previstas.', color: 'bg-blue-600', badge: 'bg-blue-100 text-blue-800', border: 'border-blue-300' },
  { num: '02', label: 'ONDE SERÁ EXECUTADO (CNES)', desc: 'Identificação completa do estabelecimento de saúde onde as atividades serão realizadas, por meio do CNES.', color: 'bg-green-600', badge: 'bg-green-100 text-green-800', border: 'border-green-300' },
  { num: '03', label: 'POR QUE SERÁ REALIZADO (Justificativa)', desc: 'Justificativa técnica que fundamenta a necessidade da ação e sua relevância para a população e para o SUS.', color: 'bg-red-600', badge: 'bg-red-100 text-red-800', border: 'border-red-300' },
  { num: '04', label: 'COM QUAIS RECURSOS (Custeio)', desc: 'Detalhamento dos recursos financeiros necessários, com justificativa dos itens de despesa e valores.', color: 'bg-amber-500', badge: 'bg-amber-100 text-amber-800', border: 'border-amber-300' },
  { num: '05', label: 'QUAL A META A SER ALCANÇADA (Meta)', desc: 'Definição das metas quantitativas e/ou qualitativas, bem como os resultados esperados com a execução.', color: 'bg-purple-600', badge: 'bg-purple-100 text-purple-800', border: 'border-purple-300' },
] as const;

// ─── Helpers para justificativa com 5 critérios SAES ─────────────────────────
export const SAES_LABELS_SHORT = [
  'O QUE SERÁ REALIZADO',
  'ONDE SERÁ EXECUTADO (CNES)',
  'POR QUE SERÁ REALIZADO',
  'COM QUAIS RECURSOS',
  'QUAL A META A SER ALCANÇADA',
];
export function parseJustCriterios(raw: string): string[] {
  if (!raw) return ['', '', '', '', ''];
  try {
    const p = JSON.parse(raw);
    if (p?._saes === 2 && Array.isArray(p.c) && p.c.length === 5) return p.c as string[];
  } catch {}
  return [raw, '', '', '', ''];
}
export function serializeJustCriterios(fields: string[]): string {
  return JSON.stringify({ _saes: 2, c: fields });
}
export function justDisplayText(raw: string): string {
  if (!raw) return '';
  try {
    const p = JSON.parse(raw);
    if (p?._saes === 2 && Array.isArray(p.c)) {
      return p.c
        .map((t: string, i: number) => t?.trim() ? `${SAES_LABELS_SHORT[i]}:\n${t}` : '')
        .filter(Boolean)
        .join('\n\n');
    }
  } catch {}
  return raw;
}
